import React, { FC, useCallback, useContext } from 'react';

import { OperatorProps } from '../../../../@types/TemplateOperators';
import { TemplateEntityContext } from '../../../../context/TemplateEntityContext';
import { ArgsSelect } from './BasicComponents';
import { validateColumnInitValue } from './utils';
import { EntityTypes } from '../../../../@types/Templates';

const Reference: FC<OperatorProps> = ({ step, handleArgsChange }) => {
  const [entityName, columnNumber] = step.args;

  const {
    referenceData: { fields: referenceFields }
  } = useContext(TemplateEntityContext);
  const options = referenceFields[entityName as EntityTypes]
    ? // @ts-ignore
      referenceFields[entityName].map((value: string, idx: number) => ({
        label: `(${++idx}) ${value}`,
        value: idx
      }))
    : [];
  const columnInitialValue = validateColumnInitValue(columnNumber, options.length);
  const entityNameInitialValue = entityName || null;

  const entityNameOptions = Object.keys(referenceFields)
    .filter((key: string) => key === 'benefitSponsorsGroups')
    .map((key: string) => ({
      label: key,
      value: key
    }));

  const entityNameHandler = useCallback(
    (value: number | string): void => {
      handleArgsChange([value, columnNumber]);
    },
    [columnNumber, handleArgsChange]
  );

  const columnValueHandler = useCallback(
    (value: number | string): void => {
      handleArgsChange([entityName, value]);
    },
    [entityName, handleArgsChange]
  );

  return (
    <>
      <div className="flex mt-6 w-1/2">
        <ArgsSelect
          argsSelectLabel="entity"
          options={entityNameOptions}
          onChange={entityNameHandler}
          value={entityNameInitialValue}
          label="Name of the file to reference"
        />
      </div>
      <div className="flex mt-6 w-1/2">
        <ArgsSelect
          argsSelectLabel="column"
          options={options}
          onChange={columnValueHandler}
          value={columnInitialValue}
          label="Column number from the selected file"
        />
      </div>
    </>
  );
};

export default Reference;
